export const validatePlannedMaintenanceNTE = (
	rule,
	val,
	callback,
	formData,
	approvalHierarchy,
	isAdmin,
	isAssignedToInternalSupplier,
	setState,
	isSameNTE = true
) => {
	const value = parseFloat(val);
	const isEmpty = val === undefined || val === '' || isNaN(value);
	if (isEmpty && !isAssignedToInternalSupplier && isSameNTE) {
		callback(new Error(`Please enter an NTE.`));
		setState({
			nteStatus: 'error',
			nteMessage: `Please enter an NTE.`,
		});
	} else if (
		approvalHierarchy.amount &&
		value > parseInt(approvalHierarchy.amount) &&
		value !== formData.nte
	) {
		callback(
			isAdmin
				? undefined
				: new Error(
						`This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto $${approvalHierarchy.amount}`
				  )
		);
		setState({
			nteStatus: isAdmin ? 'warning' : 'error',
			nteMessage: `This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto $${approvalHierarchy.amount}`,
		});
	} else {
		callback();
		setState({
			nteStatus: undefined,
			nteMessage: undefined,
		});
	}
};
